import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/medical-history/thoracotomies";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	thoracotomies: {
		id: "form.thoracotomies",
		defaultMessage: "Thoracotomiák száma és leírása"
	},
	value: {
		id: "form.thoracotomies.value",
		defaultMessage: "Thoracotomiák/sternotomiák száma"
	},
	summary: {
		id: "form.thoracotomies.summary",
		defaultMessage: "Thoracotomiák/sternotomiák leírása"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	summary: {
		type: "field",
		path: ["summary"],
		label: messages.summary,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.value }] },
		{ columns: [{ width: 12, field: fields.summary }] }
	]
};

export const node: LeafNode = {
	id: "thoracotomies",
	value: {
		title: messages.thoracotomies,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
